import React from "react";

import "./styles.scss";
import { FOOTER_LINKS_DATA } from "../../../../constants/content/shared/footer/links";
import { Link } from "react-router-dom";

const FooterLinks = () => {
  const firstLineLinks = FOOTER_LINKS_DATA.filter((link) => link.isFirstLine);
  const secondLineLinks = FOOTER_LINKS_DATA.filter((link) => !link.isFirstLine);

  return (
    <div className="Footer-links">
      <div className="Footer-links-first-line">
        {firstLineLinks.map((link) => (
          <Link className="Footer-links-link" key={link.title} to={link.link}>
            {link.title}
          </Link>
        ))}
      </div>
      <div className="Footer-links-second-line">
        {secondLineLinks.map((link) => (
          <Link className="Footer-links-link" key={link.title} to={link.link}>
            {link.title}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FooterLinks;
